import React from 'react';
import { NavigationButton } from 'ui/RaceNavigation';

const RaceLine = ({
    raceNumbers,
    raceIndex,
    setRaceIndex,
    fadedRaceNumbers,
}) => {
    return raceNumbers.map((raceNumber, index) => {
        return (
            <NavigationButton
                onClick={() => setRaceIndex(raceNumbers.indexOf(raceNumber))}
                active={raceIndex === index}
                accent={
                    fadedRaceNumbers.length > 0 &&
                    fadedRaceNumbers.includes(raceNumber)
                }
                key={index}
            >
                {raceNumber}
            </NavigationButton>
        );
    });
};

export default RaceLine;
